import React, { Component } from "react";
import PropTypes from "prop-types";

import { storageKeys, appURL } from "settings";
import { APIHandler, Image, StorageHandler, Progress, DataHandler } from "C4";
import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const createSubAppUrl = (
  subAppId,
  chapterId,
  email,
  currentPage,
  progressPercentage,
  autoTranslateAI
) => {
  // const demo = 'http://localhost:8081';
  const live = "https://academy.travpromobile.com";
  let type = "training";
  let pageId = currentPage;
  const redirurl = window.location.href;
  const params = new URLSearchParams(window.location.search);
  let lang = "";
  if (params.get("lang")) {
    lang = params.get("lang");
  }
  if (progressPercentage === 100) {
    type = "retain";
    pageId = 0;
  }

  console.log("autoTranslateAI", autoTranslateAI);
  if (autoTranslateAI) {
    // Auto translate is enabled, so we need to get the language from the local storage and use in URL
    let langLocal = localStorage.getItem("lang");
    if (langLocal) {
      langLocal = JSON.parse(langLocal);
      if (langLocal.rawData.code === "gb") {
        lang = "EN-GB";
      } else {
        lang = langLocal.rawData.langFile;
      }
      lang = lang.toUpperCase();
    }

    return `${live}/${type}/${subAppId}/${email}/${chapterId}/${pageId}/${true}/${true}?lang=${lang}&redirurl=${redirurl}`;
  }
  return `${live}/${type}/${subAppId}/${email}/${chapterId}/${pageId}/${true}/${true}?lang=${lang}&redirurl=${redirurl}`;
};

const shareAnalytics = (name, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = "guest";
      if (userObj && userObj.response && userObj.response.email) {
        ({ email } = userObj.response);
      }
      APIHandler.trackEvent(appId, "", email, "xpopro", name, value, true).then(
        () => {}
      );
    });
  });
};
export default class SubAppButton extends Component {
  constructor(props) {
    super(props);

    const { src, customName, appId, appIcon } = this.props;

    let newSrc = src;
    const name = customName.length > 0 ? customName : "Icon-180";
    if (newSrc.length === 0) {
      if (appId > 500) {
        newSrc = appIcon;
      } else {
        newSrc = `https://cdn.travpromobile.com/apptool/app/${appId}/images/${name}.png`;
      }
    }

    this.state = {
      appId,
      pageId: 0,
      src: newSrc,
      redir: "",
    };
  }

  render() {
    const { src } = this.state;
    const {
      locked,
      appId,
      size,
      progress: userProgress,
      name,
      type,
      chapterId,
      email,
      pageId,
      firstName,
      lastName,
      autoTranslateAI,
    } = this.props;

    let percentage = Math.min(
      (userProgress.progress / (userProgress.total_pages - 1)) * 100,
      100
    );
    if (email === "preview@travpromobile.com") {
      percentage = 100;
    }

    const subAppUrl = createSubAppUrl(
      appId,
      chapterId,
      email,
      pageId,
      percentage,
      autoTranslateAI
    );

    return (
      <div
        className={`subApp__Card ${
          (type === "retain" && percentage < 100) || locked ? "locked" : ""
        }`}
      >
        {percentage >= 100 && (
          <a
            href={`https://stack.travpromobile.com/download.php?name=${encodeURIComponent(
              name
            )}_badge.png&url=${`https://cms.travpromobile.com/api/app/diploma?first_name=${encodeURIComponent(
              firstName
            )}&last_name=${encodeURIComponent(
              lastName
            )}&app_id=${appId}&email=${encodeURIComponent(email)}`}`}
            className="badge"
          >
            <FontAwesomeIcon icon={["fas", "file-certificate"]} />{" "}
            {i18n.translate("reportCard.download")} <br /> Badge
          </a>
        )}
        <a
          href={subAppUrl}
          onClick={() => {
            shareAnalytics("open-training", chapterId);
          }}
        >
          <div
            className={`subApp__Card--content ${type} ${
              percentage < 100 ? "locked" : ""
            }`}
          >
            {locked && (
              <div className="locked__overlay">
                <p>{i18n.translate("trainingScreens.unlockSpecialization")}</p>
              </div>
            )}
            <div style={{ backgroundImage: `url(${src})` }} />
            <h4>{name}</h4>
          </div>
          {type === "training" && (
            <Progress id={`SubAppButton_${src}`} value={percentage} />
          )}
        </a>
      </div>
    );
  }
}

SubAppButton.propTypes = {
  locked: PropTypes.bool,
  appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  appId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  email: PropTypes.string,
  customName: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  chapterId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  progress: PropTypes.shape({
    progress: PropTypes.number,
    last_page: PropTypes.number,
    total_pages: PropTypes.number,
    inserted_at: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  name: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  autoTranslateAI: PropTypes.bool,
};

SubAppButton.defaultProps = {
  appId: -1,
  chapterId: -1,
  customName: "",
  src: "",
  size: { height: 50, width: 50 },
  pageId: 0,
  email: "",
  name: "Level II Chapter",
  badge: "",
  firstName: "",
  lastName: "",
  autoTranslateAI: false,
};
